<template>
  <div>
    <Toolbar :handle-submit="onSendForm" :handle-reset="resetForm">
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-ticket</v-icon>{{$t('ticket.ticketstatus')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>
    <TicketstatusForm ref="createForm" :values="item" :errors="violations" />
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import TicketstatusForm from '../../components/ticketstatus/Form';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import CreateMixin from '../../mixins/CreateMixin';

const servicePrefix = 'Ticketstatus';

const { mapFields } = createHelpers({
  getterType: 'ticketstatus/getField',
  mutationType: 'ticketstatus/updateField'
});

export default {
  name: 'TicketstatusCreate',
  servicePrefix,
  mixins: [CreateMixin],
  components: {
    Loading,
    Toolbar,
    TicketstatusForm
  },
  data() {
    return {
      item: {}
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations'])
  },
  methods: {
    ...mapActions('ticketstatus', ['create', 'reset'])
  }
};
</script>
